// client/src/components/Admin/Dashboard/_shared/DashboardModeToggle.js
//
// M06 ext - Toggle General / Plataforma para el dashboard.
// - General: backend devuelve ficticio + real acumulados.
// - Plataforma: backend devuelve solo lo medido en AccessLog.
//
// Persistencia en localStorage con clave 'dashboard.mode'. Default: general.

import React from "react";
import { Segmented } from "antd";
import styles from "./DashboardModeToggle.module.scss";

export const DASHBOARD_MODE_KEY = "dashboard.mode";

export function readStoredMode() {
  try {
    const v = localStorage.getItem(DASHBOARD_MODE_KEY);
    return v === "platform" ? "platform" : "general";
  } catch (e) {
    return "general";
  }
}

export function persistMode(mode) {
  try {
    localStorage.setItem(DASHBOARD_MODE_KEY, mode);
  } catch (e) {
    /* noop */
  }
}

export function DashboardModeToggle({ value, onChange }) {
  return (
    <div className={styles.modeToggle}>
      <span className={styles.label}>Vista</span>
      <Segmented
        size="small"
        value={value}
        onChange={(v) => {
          persistMode(v);
          onChange?.(v);
        }}
        options={[
          { label: "General", value: "general" },
          { label: "Plataforma", value: "platform" },
        ]}
      />
    </div>
  );
}
